<template>
    <div class="main">
        <Steps :index="0" product-name="投标保证金保险" />
        <ApplicantCompany :info="info.applicantList[0]" @on-change="setApplicantData" ref="applicant" title="投保企业信息"/>
        <ApplicantCompanyInsure :info="info.insuredList[0]" @on-change="setApplicantData" ref="applicantInsure"/>
        <RecognizeCompany ref="recognize" :info="info" @set-amount="setAmount" />
        <Invoice :info="info.invoiceInfo" ref="invoice" class="mt20" />
        <div class="mt20 center">
            <p>总费用：<span class="price">{{ amount }}元</span></p>
            <p class="mt10">
                <Button type="primary" @click="sub" :loading="loading">立即投保</Button>
            </p>
        </div>
    </div>
</template>
<script>
import Steps from '../common/Steps'
import RecognizeCompany from './RecognizeCompany'
import ApplicantCompany from './common/ApplicantCompany'
import ApplicantCompanyInsure from './common/ApplicantCompanyInsure'

import Invoice from './common/InvoiceCompany'
import { mapState } from 'vuex'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
    mixins:[ track ],
    components: { Steps, Invoice,RecognizeCompany,ApplicantCompany, ApplicantCompanyInsure,TrackNotice },
    data() {
        return {
            info: {
                invoiceInfo: {
                    invoiceType:'NOT'
                },
                applicantList:[{
                    idType:"UNIFIED_SOCIAL_CREDIT_CODE"
                }],
                insuredList:[{
                    idType:"UNIFIED_SOCIAL_CREDIT_CODE"
                }],
                productCode: this.$route.query.productCode || 'JIANGONG_DEPOSIT'
            },
            amount: '',
            loading: false,
            id: this.$route.query.id,
            isRenew: this.$route.query.renew || ''
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.common.info
        })
    },
    watch: {
        userInfo() {
            this.checkLogin()
        }
    },
    created() {
        if (this.checkLogin && this.id) {
            this.getInfo()
        }
    },
    mounted(){
		// 重新投保
		if(this.id&&this.isRenew){
			this.track_is_new = true;
			this.$nextTick(()=>{
				this.trackInit();
			})
		} else {
			// 回溯 开始录制
			this.$nextTick(this.startRecord);
		}
	},
    methods: {
        checkLogin() {
            // 检测登录
            if (!this.userInfo.userId) {
                if (location.href && location.href.indexOf('/common.html#/login') == -1) {
                    window.location = location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(location.href);
                }
                return false
            } else {
                return true
            }
        },
        // 根据id获取信息
        async getInfo() {
            let obj = {}
            let url = ''
            obj.applicationId = this.$route.query.id
            url = '/broker/insurance/application/detail.admin'
            let res = await this.$axios.post(url, obj)
            this.info = res;
        },
        // 校验
        async sub() {
            let applicant = await this.$refs.applicant.val();
            let applicantInsure = await this.$refs.applicantInsure.val();
            console.log(recognize,this.$refs.recognize,'applicantapplicantapplicant')
            let recognize = await this.$refs.recognize.val();
            let invoice = await this.$refs.invoice.val();
            
            if (!applicant) {
                this.toast('投保企业信息校验失败', 'error');
                return;
            }
            if (!applicantInsure) {
                this.toast('被保企业信息校验失败', 'error');
                return;
            }
            if (!recognize) {
                return;
            }
            if (!invoice) {
                this.toast('发票信息校验失败', 'error');
                return;
            }
            this.$axios.post(`/broker/insurance/application/apply.json.all`, {
                applicantList:[{
					...applicant,
					subjectType:'APPLICANT'
				}],
                insuredList:[{
					...applicantInsure,
					subjectType:'INSURED'
				}],
                ...recognize,
                premium: this.amount,
                bizId: "JIANGONG_DEPOSIT",
                insuranceType: 'NEW',
				invoiceInfo:invoice,
                insuranceApplicationId:this.$route.query.id?this.$route.query.id:null
            }).then(async res => {
                this.loading = false;
                if (res.code == 10000000) {
                    // 回溯 停止录制
					await this.stopRecord({
						session_key:sessionStorage.track_session_key,
						policy_id:res.msg||''
					});
                    this.toast('提交成功')
                    this.$router.replace(`/customized-employer-liability/ConfirmCompany/${res.data}?productCode=${this.info.productCode}`)
                } else {
                    this.alert(res.msg)
                }

            })
        },
        // 设置总费用
        setAmount(amount) {
            this.amount = amount;
        },
        // 同步投保公司数据，用于更新公司名称和社会代码，开票组件会用到
        setApplicantData(form) {
			this.$set(this.info,'invoiceInfo',{
				...this.info.invoiceInfo,
				...form
			})
		},
        changeCost(val) {
            this.$set(this.info, 'projectCost', val)
        },
    }
}
</script>
<style scoped>
.main {
    margin-top: 15px;
    padding: 30px 40px;
}

.mt20 {
    font-size: 25px;
    line-height: 1.8;
}

span.price {
    color: #FF0000;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/FillinCompany.vue